module.exports = __webpack_public_path__ + "img/11.53fe9d67.jpg";